import * as React from 'react';
import { useWatch, type Control, type FieldValues } from 'react-hook-form';

import { HtmlTemplatePreview } from '../composites/TemplateRichTextEditor';
import { FormField } from '../patterns/FormField';

import type { RhfFormFieldShellProps, RhfLayoutProps } from './rhfLayout';

export interface RhfHtmlPreviewProps extends RhfLayoutProps, RhfFormFieldShellProps {
  control: Control<FieldValues>;
  /** Layout field name (not bound to RHF value). */
  name: string;
  label: string;
  /** Form field whose HTML is rendered (e.g. message). */
  sourceField: string;
  semanticId?: string;
}

export const RhfHtmlPreview = React.forwardRef<HTMLDivElement, RhfHtmlPreviewProps>(
  function RhfHtmlPreview(
    { control, label, sourceField, semanticId, hint, tooltip, controlWidth },
    ref,
  ) {
    const html = useWatch({ control, name: sourceField });

    return (
      <FormField
        ref={ref}
        label={label}
        hint={hint}
        tooltip={tooltip}
        semanticId={semanticId}
        controlWidth={controlWidth}
      >
        <HtmlTemplatePreview html={typeof html === 'string' ? html : ''} />
      </FormField>
    );
  },
);

RhfHtmlPreview.displayName = 'RhfHtmlPreview';
